import { useState } from "react";
import { Bell, ChevronDown } from "lucide-react";
import { TermsVariables } from "./TermsModal";
import { cn } from "@/lib/utils";

interface WinnerNotificationInfoProps {
  termsVariables: TermsVariables;
}

export function WinnerNotificationInfo({ termsVariables }: WinnerNotificationInfoProps) {
  const [winnerInfoExpanded, setWinnerInfoExpanded] = useState(false);

  const method = termsVariables.winnerNotificationMethod || "email";
  const timeframe = termsVariables.winnerNotificationTimeframe || "7 days";
  const responseWindow = termsVariables.responseWindow || "48 hours";

  return (
    <div className="fade-in">
      <button
        onClick={() => setWinnerInfoExpanded(!winnerInfoExpanded)}
        className="flex items-center justify-between w-full py-2 group hover:bg-muted/30 transition-colors rounded-lg px-1 -mx-1"
        type="button"
      >
        <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
          <Bell className="w-4 h-4" />
          <span>Winner Notification</span>
        </div>
        <ChevronDown
          className={cn(
            "w-4 h-4 text-muted-foreground transition-transform duration-200",
            winnerInfoExpanded ? "rotate-180" : ""
          )}
        />
      </button>

      {winnerInfoExpanded && (
        <div className="text-sm text-muted-foreground pb-3 px-1 animate-in slide-in-from-top-1 fade-in duration-200">
          <p>
            Winners will be notified via {method} within {timeframe} after the competition ends.
            If we don't hear back within {responseWindow}, we may select another winner.
          </p>
        </div>
      )}
    </div>
  );
}